import { Component, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, Renderer2, ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import * as _ from 'lodash';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { OrderBillBus } from '@app/cp/shared/models/OrderBillBus';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { OrderBillDetailsBus } from '@app/cp/shared/models/OrderBillDetailsBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseGridEditAllLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-alllines.component';
import { OrderBillUIParam } from '@app/cp/shared/models/OrderBillUIParam';
import { OrderBillDetailItemsComponent } from './bill-details/bill-detail-items/order-bill-detail-items.component';
import { OrderBillPaymentsComponent } from './bill-details/bill-payments/order-bill-payments.component';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { IFeatureFlagSet, UseFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';
import { ConfirmOutput } from '../../../shared/models/ConfirmOutput';
import { CRUDActions } from '../../../shared/enums/CRUDActions';
import { CPDialogResult } from '../../../shared/enums/CPDialogResult';
import { DQOIOrderDisplaySettings } from '../../../shared/models/DQOIDisplaySettings';

@UseFeatureFlagSet()
@Component({
    selector: 'order-bill-details',
    templateUrl: './order-bill-details.component.html',
    styleUrls: ['./order-bill-details.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrderBillDetailsComponent extends BaseGridEditAllLinesComponent<OrderBillBus, null, OrderService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "OrderBillBus";
        this.disableCpSearchDialog();
    }
    @ViewChild('billDetails') protected orderBillDetailItemsComponent: OrderBillDetailItemsComponent;
    @ViewChild('billPayments') protected orderBillPaymentsComponent: OrderBillPaymentsComponent;
    @ViewChildren('billDetails') protected billDetailsList: QueryList<OrderBillDetailItemsComponent>;
    @ViewChildren('billPayments') protected billPaymentList: QueryList<OrderBillPaymentsComponent>;
    @ViewChildren(OrderBillDetailItemsComponent) billDetailsList2: OrderBillDetailItemsComponent;
    @Input() testCode: string = "Z";
    @Input() dqoiOrderDisplaySettings: DQOIOrderDisplaySettings = new DQOIOrderDisplaySettings();
    @Output() quantityChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() createInvoiceEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() createSupplierCreditEvent: EventEmitter<any> = new EventEmitter<any>();
    orderBillStatus_Posted = CommonValues.OrderBillStatus_Posted;
    
    protected customSetEditRows(row: OrderBillBus): UntypedFormGroup {
        let form = new UntypedFormGroup({
            'orderBillId': new UntypedFormControl(row.orderBillId),
            'orderId': new UntypedFormControl(row.orderId),
            'amountBilled': new UntypedFormControl(row.amountBilled),
            'referenceNumber': new UntypedFormControl(row.referenceNumber),
            'orderBillStatusId': new UntypedFormControl(row.orderBillStatusId),
            'receivedById': new UntypedFormControl(row.receivedById),
            'dateReceived': new UntypedFormControl(row.dateReceived)
        });
        return form;
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    validateRow(dataItem, rowIndex, skiptotals = false) {
        var valid = true;
            let param = new OrderBillUIParam();
            var amountEntered = dataItem.amountBilled;
            var amountEnteredCalc = 0;
            this.gridData[rowIndex].amountBilled = dataItem.amountBilled;
            this.gridData[rowIndex].referenceNumber = dataItem.referenceNumber;
            this.gridData[rowIndex].dateReceived = dataItem.dateReceived;
            let billDetails = this.gridData[rowIndex].orderBillDetails;
            //calculate the total of the selected line items for this bill
            if (billDetails) {
                let tempTotal: number = 0;
                if (this.gridData) {
                    for (let i = 0; i < billDetails.length; i++) {
                        if (billDetails[i].quantityBilled !== 0) {
                            tempTotal += CommonFunctions.RoundToPrecision((billDetails[i].quantityBilled * billDetails[i].price), 2);
                        }
                    }
                }
                
                amountEnteredCalc = CommonFunctions.RoundToPrecision(tempTotal, 2);                
            }
            if (!skiptotals && (this.gridData[rowIndex].orderBillStatusId !== CommonValues.OrderBillStatus_ForReview && 
                    this.gridData[rowIndex].orderBillStatusId !== CommonValues.OrderBillStatus_InvalidMatch)) {                
                if (amountEntered != amountEnteredCalc) {
                    valid = false;
                }
            }
            if (!dataItem.referenceNumber) {
                valid = false;
            }
            this.gridData[rowIndex].rowValid = valid;
            if (!valid) {
                this.gridValid = false;
            }
        return valid;
    }
    gridValid = false;
    checkGridValid(skiptotals = false) {
        this.gridValid = true;
        for (let i = 0; i < this.gridData.length; i++) {
            this.validateRow(this.gridData[i], i, skiptotals)
        }
    }
    createInvoice(data:any) {

        this.cnfShow("Do you want to create the Invoice?", CRUDActions.Create, data);
    }
    createSupplierCredit(data: any) {

        this.cnfShow("Do you want to create the Supplier Credit?", CRUDActions.Update, data);
    }
    confirmDialog(data: ConfirmOutput) {
        this.closeCtrlOpenFlag = true;
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {
            switch (data.action) {
                case CRUDActions.Create:
                    handled = true;
                    this.createInvoiceEvent.emit(data.data.orderBillId);
                    break;
                case CRUDActions.Update:
                    handled = true;
                    this.createSupplierCreditEvent.emit(data.data.orderBillId);
                    break;
            }
        }
        if (data.dialogResult === CPDialogResult.ok) {
            switch (data.action) {
                case CRUDActions.Delete:
                    handled = true;
                    if (data.data.isAdded) {
                        this.removeLocal(data.data);
                        //this.closeEditor();
                        this.deletedLocalNoId();
                        this.afterDelete();
                    }
                    else {
                        this.delete(data.data);
                    }
                    break;
            }
        }
    }
    public getDeletedItems() {
        var deletedItems = _.cloneDeep(this.deletedItems);
        if (this.billPaymentList) {
            var adjRowIndex = -1;
            for (let ii = 0; ii < this.billPaymentList.length; ii++) {
                var dDelete = this.billPaymentList.toArray()[ii].getDeletedItems()
                if (dDelete.length > 0) {
                    for (let iii = 0; iii < dDelete.length; iii++) {
                        deletedItems.push(dDelete[iii]);
                    }
                }
            }
        }
        return deletedItems
    }
    amountBilledChanged(e, dataItem, edtForm, rowIndex) {
        if (edtForm) { dataItem.referenceNumber = edtForm.values.referenceNumber }
        if (!dataItem.isAdded) { dataItem.isUpdated = true; }
        this.validateRow(dataItem, rowIndex)
        this.checkGridValid()
        this.changed.emit(this.gridValid);
    }
    dateBilledChanged(e, dataItem, edtForm, rowIndex) {
        if (!dataItem.isAdded) { dataItem.isUpdated = true; }
        this.validateRow(dataItem, rowIndex);
        this.checkGridValid();
        this.changed.emit(this.gridValid);
    }
    refNoChanged(e, dataItem: OrderBillBus, edtForm, rowIndex) {
        if (!dataItem.isAdded) { dataItem.isUpdated = true; }
        this.validateRow(dataItem, rowIndex);
        this.checkGridValid();
        this.changed.emit(this.gridValid);
    }

    orderBillDetailsGrid: OrderBillDetailsBus[];

    addHandler(): boolean {
        super.addHandler();
        var orderBillId = CommonFunctions.getGuid();
        this.gridData[this.gridData.length - 1].orderBillStatusId = CommonValues.OrderBillStatus_Received;
        this.gridData[this.gridData.length - 1].dateReceived = DateFunctions.getDateNow();
        this.gridData[this.gridData.length - 1].receivedById = this.globals.personId;
        this.gridData[this.gridData.length - 1].orderBillId = orderBillId;
        this.gridData[this.gridData.length - 1].isAdded = true;
        this.gridData[this.gridData.length - 1].dataLoading = true;
        this.svc_data.getOrderBillDetailsGrid(this._parentId, CommonValues.Guid_Empty).subscribe((info: BaseMessageInfo) => {

            let hasData: boolean = !info.saveError && CommonFunctions.hasValue(info.primaryReturn);
            if (hasData) {
                //                let busObj: OrderBillBus = dataItem;
                var arr = [];
                for (let i = 0; i < info.primaryReturn.length; i++) {
                    let detObj = new OrderBillDetailsBus(info.primaryReturn[i]);
                    detObj.orderBillId = orderBillId;
                    detObj.quantityBilled = 0;
                    detObj.isAdded = true;
                    arr.push(detObj);
                }
                this.gridData[this.gridData.length - 1].orderBillDetails = arr;

                this.grid.expandRow(this.gridData.length - 1);
                if (CommonFunctions.hasValue(this.orderBillDetailItemsComponent)) {
                    this.orderBillDetailItemsComponent.edit(true);
                }
                //this.gridData.push(busObj);
            }
            this.gridData[this.gridData.length - 1].dataLoading = false;
        });

        return true;
    }
    refNoBlur(e, dataItem: OrderBillBus, edtForm, rowIndex) {
        this.validateRow(dataItem, rowIndex)
        this.checkGridValid()
        this.changed.emit(this.gridValid);
    }
    expandAll() {

        this.gridValid = true;
        if (this.gridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                this.grid.expandRow(i);
            }
        }

    }
    amountBilledBlur(e, dataItem: OrderBillBus, edtForm, rowIndex) {

    }
    afterDelete() {
        this.checkGridValid();
        this.quantityChanged.emit(this.gridValid);
    }

    billStatusCBOChanged(rowIndex) {
        if (!this.gridData[rowIndex].isAdded) { this.gridData[rowIndex].isUpdated = true; }

        this.checkGridValid();
        
        this.quantityChanged.emit(this.gridValid);
    }

    onQuantityChanged(data: OrderBillUIParam, rowIndex) {
        if (!Array.isArray(data.data) || data.data.length < 1) {
            return;
        }
        
        var orderBillId = data.data[0].orderBillId;
        rowIndex = this.gridData.findIndex(e => e.orderBillId == orderBillId);
        if (rowIndex >= 0) {
            this.validateRow(this.gridData[rowIndex], rowIndex);
            this.checkGridValid();
            if (!this.gridData[rowIndex].isAdded) { this.gridData[rowIndex].isUpdated = true;}
            this.quantityChanged.emit(this.gridValid);
        }
    }
    onChanged(data: OrderBillUIParam) {
        if (data.canSavePaymentInfo == false) {
            this.changed.emit(false);
        } else {
            if (!Array.isArray(data.data) || data.data.length < 1) {
                return;
            }
            var orderBillId = data.data[0].orderBillId;
            var rowIndex = this.gridData.findIndex(e => e.orderBillId == orderBillId);
            if (rowIndex >= 0) {
                this.validateRow(this.gridData[rowIndex], rowIndex, true);
                this.checkGridValid(true);
                if (!this.gridData[rowIndex].isAdded) { this.gridData[rowIndex].isUpdated = true; }
                this.quantityChanged.emit(this.gridValid);
            }
            this.changed.emit(this.gridValid);
        }
    }
    getChangedObject(dataObj: OrderBillBus) {
        let busObj: OrderBillBus = new OrderBillBus(dataObj,false);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }
    public getChanged(param: any = null): any {
        let changedData: OrderBillBus[] = [];
        if (this.hasGridData) {
            console.log("ordbdet-getch: ", this.gridData);
            for (let i = 0; i < this.gridData.length; i++) {

                let dataObj: OrderBillBus = this.getChangedObject(this.gridData[i]);
                let orderBillDetails = null;
                let orderBillPayments = null;

                if (this.gridData[i].isUpdated || this.gridData[i].isAdded) {

                    if (this.billDetailsList) {
                        var adjRowIndex = -1;
                        for (let ii = 0; ii < this.billDetailsList.length; ii++) {
                            if (this.billDetailsList.toArray()[ii].curId() == this.gridData[i].orderBillId) {
                                adjRowIndex = ii;
                            }
                        }
                        if (adjRowIndex > -1) { orderBillDetails = this.billDetailsList.toArray()[adjRowIndex].getChanged(this.gridData[i].CID()); }
                    }

                    if (this.billPaymentList) {
                        var adjRowIndex = -1;
                        for (let ii = 0; ii < this.billPaymentList.length; ii++) {
                            if (this.billPaymentList.toArray()[ii].curId() == this.gridData[i].orderBillId) {
                                adjRowIndex = ii;
                            }
                        }
                        if (adjRowIndex > -1) { orderBillPayments = this.billPaymentList.toArray()[adjRowIndex].getChanged(this.gridData[i].CID()); }
                    }

                    if (this.orderBillPaymentsComponent) {
                        orderBillPayments = this.orderBillPaymentsComponent.getChanged(this.gridData[i].CID());
                    }
                    if (CommonFunctions.hasArrayElementValue(orderBillDetails)) {
                        dataObj.orderBillDetails = orderBillDetails;
                    }
                    if (CommonFunctions.hasArrayElementValue(orderBillPayments)) {
                        dataObj.orderBillPayments = orderBillPayments;
                    }
                    changedData.push(dataObj);

                }
            }
        }
        return changedData;
    }

    //dont allow zuggit invoice automation for these statuses
    checkCanCreateInvoice(dataItem) : boolean {
        return dataItem.orderBillStatusId !== CommonValues.OrderBillStatus_ForReview && dataItem.OrderBillStatusId !== CommonValues.OrderBillStatus_InvalidMatch;
    }
    checkCanSupplierCredit(dataItem): boolean {
        return dataItem.invoiceStatusId == CommonValues.Invoice_Completed || dataItem.invoiceStatusId == CommonValues.Invoice_WaitingForPayment;
    }
}
